export enum LinkHrefType {
  Phone = 'tel:',
  Email = 'mailto:',
  Sms = 'sms:',
  Fax = 'fax:'
}
